<template>
    <div :data-component="$options.name">
        <cs-tiles-result-list
            :hideImages="computedHideImages"
            :renderedItems="renderedItems"
            :showButton="showButton"
            :isDisabled="isDisabled"
            :isLoading="isLoading"
            :allDisturber="allDisturber"
            :trackings="trackings"
            @page:up="onClick"
        >
            <template #headline>
                <ms-text :contentTag="headline"></ms-text>
            </template>
            <template #notifications>
                <cs-notification
                    v-if="showNotification"
                    notificationState="info"
                    class="mb-24"
                    :data-jest="isFallback ? 'noteFallback' : 'noteEmpty'"
                >
                    <template #headline> Keine Treffer </template>
                    <template v-if="isCountyFallback || isFederalStateFallback">
                        Hier gibt es aktuell keine Neuigkeiten, daher siehst du alle Meldungen aus
                        {{ fallbackLocationName }}. Schaue ansonsten später nochmal rein.
                    </template>
                    <template v-else> Hier gibt es aktuell keine Neuigkeiten. </template>
                </cs-notification>
            </template>
            <template #filter>
                <div class="flex justify-between w-full screen-m:justify-normal screen-l:self-end">
                    <!-- no filter (fake or real) at the moment; may come back
                    <button
                        class="flex items-center font-bold text-text-l hover:underline screen-m:mr-16"
                        aria-label="Filter öffnen"
                        aria-haspopup="true"
                        @click="openModal"
                    >
                        <ms-settings class="w-24 h-24 mr-8 screen-m:ml-8 hover:cursor-pointer" /> Filter
                    </button>
                -->
                    <!-- css style necessary for now until filter are enabled again if it stays like this height should be maintainable in CsModal -->
                    <!-- no filter (fake or real) at the moment; may come back
                    <cs-modal
                        :visible="modalVisible"
                        channel="local-information"
                        @update:visible="closeModal"
                    >
                        <template #content>
                            <div class="p-16 rounded-10 bg-color-greyscale-white">
                                Hier findest du demnächst verschiedene Möglichkeiten, um die Nachrichten zu filtern.
                            </div>

                            <div class="grid gap-16">
                                <div class="px-16 rounded-10 bg-color-greyscale-white">
                                    <cs-accordion
                                        :isInitiallyOpen="true"
                                        :label="'Kategorie'"
                                        class="w-full"
                                    >
                                        <div class="flex w-full">
                                            <cs-news-category
                                                :filterValues="filterValues"
                                                :selectedCategories="selectedCategories"
                                                @update:modelValue="onCategoryFilterChange"
                                            />
                                        </div>
                                    </cs-accordion>
                                </div>
                                <div class="px-16 rounded-10 bg-color-greyscale-white">
                                    <cs-accordion
                                        :isInitiallyOpen="true"
                                        :label="'Zeitraum'"
                                        class="w-full"
                                    >
                                        <div class="flex w-full">
                                            <cs-timeframe v-model="selectedTimeframe" />
                                        </div>
                                    </cs-accordion>
                                </div>
                                <div
                                    v-if="locationId !== 'deutschland'"
                                    class="px-16 rounded-10 bg-color-greyscale-white"
                                >
                                    <cs-accordion
                                        :isInitiallyOpen="true"
                                        :label="'Umkreis'"
                                        class="w-full overflow-visible"
                                    >
                                        <div class="flex w-full">
                                            <cs-surrounding-area v-model="selectedSurroundingArea" />
                                        </div>
                                    </cs-accordion>
                                </div>
                            </div>
                        </template>
                        <template #buttons>
                            <cs-ghost-button
                                aria-label="Filter zurücksetzen"
                                class="justify-center text-center basis-1/2 min-h-52"
                                @click="onResetModal"
                            >
                                Zurücksetzen
                            </cs-ghost-button>
                            <cs-primary-button
                                aria-label="Modal schließen"
                                :isLoading="isLoading"
                                :isCentered="true"
                                class="basis-1/2 min-h-52"
                                @click="onFilterClick"
                            >
                                Nachrichten anzeigen
                            </cs-primary-button>
                        </template>
                    </cs-modal>
                    <span
                        class="self-center hidden w-1 h-24 mr-4 rounded-full screen-m:block bg-color-neutral-grey-10"
                    ></span>
                    -->
                    <cs-sort
                        class="screen-m:ml-16"
                        :options="sortOptions"
                        :modelValue="selectedSort"
                        @update:modelValue="updateSortOption"
                    ></cs-sort>
                </div>
            </template>
        </cs-tiles-result-list>
    </div>
</template>
<script lang="ts" src="./HydratedNewsFeedResultlist.ts" />
